module.exports = __webpack_public_path__ + "media/images/lb/443-2c7e68ac9dec95b84bbcce9b9bc8968a.svg";